import React from 'react';

import {
  AppIcon,
  AwsIcon,
  AzureIcon,
  BitbucketIcon,
  CloudIcon,
  GithubIcon,
  GitLabIcon,
  GoogleCloudIcon,
  NoneIcon,
  OktaIcon,
  SnowflakeIcon,
} from 'components/Icons';

export const groupByOptions = [
  { label: 'Cloud', value: 'cloud_provider', icon: <CloudIcon /> },
  { label: 'Category', value: 'category', icon: <AppIcon /> },
  { label: 'None', value: undefined, icon: <NoneIcon /> },
];

export const cloudProviderOptions = [
  { label: 'Cloud', value: undefined },
  { label: 'AWS', value: 'AWS', icon: <AwsIcon /> },
  { label: 'GCP', value: 'GCP', icon: <GoogleCloudIcon /> },
  {
    label: 'Azure',
    value: 'Azure',
    icon: <AzureIcon />,
  },
  /*{
    label: 'AzureAD',
    value: 'AzureAd',
    icon: <AzureActiveDirectoryIcon />,
  },*/
  { label: 'Okta', value: 'Okta', icon: <OktaIcon /> },
  {
    label: 'Snowflake',
    value: 'Snowflake',
    icon: <SnowflakeIcon />,
  },
  { label: 'GitLab', value: 'GitLab', icon: <GitLabIcon /> },
  { label: 'GitHub', value: 'GitHub', icon: <GithubIcon /> },
  {
    label: 'Atlassian BitBucket',
    value: 'BitBucket',
    icon: <BitbucketIcon />,
  },
];

export const sortByOptions = [
  { label: 'Alphabetically', value: 'Alphabetically' },
  { label: 'Count', value: 'Count' },
];
